// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  //local

 
     ENV_newbaseUrl: "https://aidemo.elihealthsupport.com/api/",
     hubUrl: "https://aidemo.elihealthsupport.com/notificationHub",
     chatbotApiUrl: "https://aidemo.elihealthsupport.com/ai/api/",
     //localtesting url
   //  ENV_newbaseUrl: "https://newserver.elihealthsupport.com/backend/api/",
   //  hubUrl: " https://newserver.elihealthsupport.com/backend/notificationHub",
   

  sidebarimage: true,
  homeimage: true,
  logoELiTitle: true,
  sidebarimagelive: false,
  homeimagelive: false,
  logoRAJASTitle: false,
  logoSRJTitle: false,
  wasa1reportTitle: true,
 // speachtotexttype:'azure',
  speachtotexttype:'browser',
  azureKey :'null'
};
